import { render, staticRenderFns } from "./DeliveryStatusWidget.vue?vue&type=template&id=1f7ecc3c&scoped=true&"
import script from "./DeliveryStatusWidget.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatusWidget.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStatusWidget.vue?vue&type=style&index=0&id=1f7ecc3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ecc3c",
  null
  
)

export default component.exports